<template>
  <section class="header d-print-none">
    <div class="container-fluid">
      <div
        class="row d-flex justify-content-center align-items-center pt-2 pb-2"
      >
        <div class="col-md-2 col-6">
          <router-link to="/">
            <img
              src="@/assets/img/logo65anosBranca.svg"
              class="img-fluid"
              width="180"
              alt="logo"
            />
          </router-link>
        </div>
        <ProdutosBuscar />
        <div class="col-6 d-md-flex col-md-5 justify-content-end">
          <!-- <router-link
            class="mi-notifications d-none d-md-flex align-items-center justify-content-center pr-3 position-relative pointer-event"
            :to="{ name: 'meuschamados' }"
          >
            <span class="as-notifications" v-if="!notificacoes">1</span>
            <span class="material-icons white">flag</span>
          </router-link> -->
          <div
            class="dropdown d-md-flex justify-content-center align-items-center white pl-3"
            id="user-menu"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              :src="
                'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=' +
                nomeComerical
              "
              class="d-md-block d-none"
              alt="user"
            />
            <div class="user-data d-md-block d-none">
              <p class="user-name">
                <b>{{ nomeComerical }}</b>
              </p>
              <p class="user-plan" v-if="nomePacote">
                <small class="text-lowercase">{{ nomePacote }}</small>
              </p>
              <p class="user-plan" v-else>
                <small class="text-lowercase">Não Associado</small>
              </p>
            </div>
            <span
              class="material-icons text-white d-flex justify-content-end d-md-none"
              >person</span
            >
            <div
              class="dropdown-menu dropdown-menu-right fade-2s"
              aria-labelledby="user-menu"
              v-if="associado"
            >
              <router-link
                :to="{ name: 'meuperfil' }"
                class="dropdown-item"
                type="button"
              >
                <span class="material-icons">person</span> Dados Cadastrais
              </router-link>
              <router-link
                :to="{ name: 'resetsenha' }"
                class="dropdown-item"
                type="button"
              >
                <span class="material-icons">https</span> Trocar Senha
              </router-link>
              <router-link
                :to="{ name: 'meuplano' }"
                class="dropdown-item"
                type="button"
              >
                <span class="material-icons">work</span> Meu Plano
              </router-link>
              <!-- <router-link
                :to="{ name: 'meuschamados' }"
                class="dropdown-item"
                type="button"
              >
                <span class="material-icons">flag</span> Meus Chamados
              </router-link> -->
              <router-link
                :to="{ name: 'calculos' }"
                class="dropdown-item"
                type="button"
              >
                <span class="material-icons">flag</span> Cálculos Econômicos
              </router-link>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" type="button" @click="logout">
                <span class="material-icons danger">exit_to_app</span>
                Desconectar
              </button>
            </div>
            <div
              class="dropdown-menu dropdown-menu-right fade-2s"
              aria-labelledby="user-menu"
              v-else
            >
              <button class="dropdown-item" type="button" @click="logout">
                <span class="material-icons danger">exit_to_app</span>
                Desconectar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ProdutosBuscar from "@/components/ProdutosBuscar.vue";
export default {
  name: "TheHeader",
  components: {
    ProdutosBuscar,
  },
  data() {
    return {
      notificacoes: [
        {
          Titulo: "Teste",
          mensagem: "Descrição do teste de notificação",
        },
      ],
      associado: true,
      nomeComerical: "",
      nomePacote: "",
    };
  },
  methods: {
    async logout() {
      await this.$store.dispatch("LOGOUT");
      // await this.$router.push({ name: "login" });
      window.location.replace("https://www.cdlbh.com.br");
    },
  },
  created() {
    if (this.$user.naoAssociado || this.$user.carteira) {
      this.associado = false;
      if (this.$user.carteira) {
        this.nomeComerical = this.$user.carteira.nome;
      } else {
        this.nomeComerical =
          this.$user.dadosCadastraisAssociado[0].nomecomercial;
      }
    } else {
      this.nomeComerical = this.$user.dadosCadastraisAssociado[0].nomecomercial;
      this.nomePacote = this.$user.pacoteSocio.nomepacote;
    }
  },
};
</script>
<style lang="scss" scoped></style>
